import { useApiQuery } from '@/api/hooks/useQuery';
import { memberInfoKeys } from '@/api/queryKeys';

/**
 * Hook to fetch the current member's profile info.
 * This mirrors the mobile app's useGetMemberInfo hook.
 *
 * Returns firstName, lastName, dateOfBirth, ethnicity, gender, avatar, etc.
 */
export function useMemberInfo() {
  return useApiQuery({
    queryKey: memberInfoKeys.detail(),
    queryFn: (api) => async () => {
      const response = await api.members.membersControllerGetMyInfo();
      return response.data;
    },
    gcTime: 0,
    staleTime: 0,
  });
}
